import './styles.scss';
import PropTypes from 'prop-types';

function TipsPanel({
    className,
    tips,
}) {
    const panelItems = tips.items || (
        tips.isLaserMode ? [
            'Left click + drag to move laser',
            'Right click + drag to pan',
            'Scroll wheel to zoom',
            'Alt/Option + left click + drag to rotate',
        ] : [
            'Left click + drag to rotate',
            'Right click + drag to pan',
            'Scroll wheel to zoom',
        ]
    );

    return (
        <div className={`tips-container ${className}`}>
            <button
                type="button"
                className="tips-toggle"
                onClick={tips.onToggle}
            >
                <i className="material-icons">
                    tips_and_updates
                </i>
            </button>

            {tips.showTips && (
                <div className="tips-panel">
                    <h4>{tips.title || 'Controls'}</h4>
                    <ul>
                        {panelItems.map((item) => (
                            <li key={item}>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

TipsPanel.propTypes = {
    className: PropTypes.string,
    tips: PropTypes.shape({
        isLaserMode: PropTypes.bool,
        items: PropTypes.arrayOf(PropTypes.string),
        onToggle: PropTypes.func.isRequired,
        showTips: PropTypes.bool.isRequired,
        title: PropTypes.string,
    }).isRequired,
};

TipsPanel.defaultProps = {
    className: '',
};

export default TipsPanel;
